import React, { memo } from 'react';
import HBMoneyInput from '../HBMoneyInput/HBMoneyInput';
import HBMoneyInputField, {
    HBMoneyInputFieldProps
} from '../HBMoneyInputField/HBMoneyInputField';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputProps,
    useFormInputValidationProps
} from './useFormFieldProps';

const HBFormMoneyInputField = (
    props: FormFieldProps<HBMoneyInputFieldProps>
) => {
    const fieldProps = useFormFieldProps(props, true);
    const validationProps = useFormInputValidationProps(props.id);

    return <HBMoneyInputField {...fieldProps} {...validationProps} />;
};

export const FormMoneyInput = memo(
    (props: FormFieldProps<HBMoneyInputFieldProps>) => {
        const inputProps = useFormInputProps(props, true);
        const validationProps = useFormInputValidationProps(props.id);

        return <HBMoneyInput {...inputProps} {...validationProps} />;
    }
);

export default memo(HBFormMoneyInputField);
